import * as React from "react";
import { Icon } from "@fluentui/react/lib/Icon";
import { Spinner } from "@fluentui/react/lib/Spinner";
import InfiniteScroll from "react-infinite-scroll-component";

import { TEXT } from "../../../../../shared/constants/texts";
import { ICON } from "../../../../../shared/constants/icons";

type InstanceListingPopupProps = {
  isLoading: any;
  loadingMsg: any;
  emptyMsg: any;
  instances: any;
  onInstanceClicked: any;
  selectedInstance: any;
  hidePopup: any;
  onDoneClicked: any;
  onSearch: any;
};

const InstancesListingPopUp: React.FC<InstanceListingPopupProps> = (props) => {
  const {
    hidePopup,
    isLoading,
    loadingMsg,
    instances,
    emptyMsg,
    onInstanceClicked,
    selectedInstance,
    onDoneClicked,
    onSearch,
  } = props;
  const [showCrossIcon, setShowCrossIcon] = React.useState(false);
  const searchInstanceRef = React.useRef(null);

  const onChangeSearchInstance = (e) => {
    e.preventDefault();
    if (searchInstanceRef.current.value.length === 0) {
      onSearch("");
      setShowCrossIcon(false);
    } else {
      setShowCrossIcon(true);
      onSearch(searchInstanceRef.current.value);
    }
  };

  const onPressEnterSearchInstance = (e) => {
    e.preventDefault();
    if (e.keyCode === 13) {
      searchInstances();
    }
  };

  const searchInstances = () => {
    const searchedValue = searchInstanceRef.current.value;
    if (searchedValue) {
      onSearch(searchedValue);
    }
  };

  const clearSearchInstance = () => {
    const searchedValue = searchInstanceRef.current.value;
    if (searchedValue) {
      searchInstanceRef.current.value = "";
      onSearch("");
      setShowCrossIcon(false);
    }
  };

  const onPressEnterCrossIcon = (e) => {
    if (e.key === TEXT.ENTER || e.keyCode === TEXT.ENTER_KEY_CODE) {
      hidePopup();
    }
  };

  const onPressEnterSearchIcon = (e) => {
    if (e.key === TEXT.ENTER || e.keyCode === TEXT.ENTER_KEY_CODE) {
      searchInstances();
    }
  };

  const onPressEnterCancelIcon = (e) => {
    if (e.key === TEXT.ENTER || e.keyCode === TEXT.ENTER_KEY_CODE) {
      clearSearchInstance();
    }
  };

  const onPressInstanceInPopup = (e, instance) => {
    if (e.key === TEXT.ENTER || e.keyCode === TEXT.ENTER_KEY_CODE) {
      onInstanceClicked(instance);
    }
  };

  return (
    <React.Fragment>
      <div className="instances-popup-container-single-email-upload">
        <div className="header-with-search-container">
          <div className="header-container">
            <p>{TEXT.MODAL_HEADER}</p>
            <div className="icon-cross-header-modal" tabIndex={1} onKeyDown={onPressEnterCrossIcon}>
              <Icon onClick={hidePopup} className="cross-icon-header" iconName={ICON.CANCEL} />
              <span className="sr-only">{TEXT.CANCEL}</span>
            </div>
          </div>
          <div className="search-box-container">
            <div className="search-box">
              <input
                ref={searchInstanceRef}
                type="text"
                placeholder={TEXT.PLACEHOLDER_SEARCH_ASSOCIATIONS}
                onChange={(e) => onChangeSearchInstance(e)}
                onKeyUp={(e) => onPressEnterSearchInstance(e)}
                tabIndex={1}
              />
              {showCrossIcon ? (
                <React.Fragment>
                  <Icon
                    onClick={clearSearchInstance}
                    className="cross-icon"
                    iconName={ICON.CANCEL}
                    tabIndex={1}
                    onKeyDown={onPressEnterCancelIcon}
                  />
                  <span className="sr-only">{TEXT.CANCEL}</span>
                </React.Fragment>
              ) : null}
              <button
                onClick={searchInstances}
                tabIndex={1}
                onKeyDown={onPressEnterSearchIcon}
                aria-labelledby="search-icon"
                aria-label="search-icon"
                id="search-icon"
              >
                <Icon className="search-icon" iconName={ICON.SEARCH} />
                <span className="sr-only">{TEXT.SEARCH}</span>
              </button>
            </div>
          </div>
        </div>
        <div className="instances-popup-listing-container">
          {isLoading ? (
            <div className="loading-instances-popup">
              <Spinner label={loadingMsg} labelPosition="right" />
            </div>
          ) : instances && instances.length > 0 ? (
            <div className="popup-instances-listing" id="id-instance-listing">
              <React.Fragment>
                <InfiniteScroll
                  dataLength={instances.length}
                  next={() => {}}
                  hasMore={false}
                  loader={<div></div>}
                  endMessage={<div></div>}
                  scrollableTarget="id-instance-listing"
                >
                  {instances.map((instance, index) => {
                    const instanceName = instance.Name ? instance.Name : instance.ICMAgreementCode;
                    return (
                      <div
                        style={
                          selectedInstance && selectedInstance.EntityInstanceId === instance.EntityInstanceId
                            ? { backgroundColor: "#f4f4f4" }
                            : null
                        }
                        className="popup-single-instance"
                        key={index}
                        onClick={() => onInstanceClicked(instance)}
                        tabIndex={1}
                        onKeyDown={(e) => onPressInstanceInPopup(e, instance)}
                      >
                        <p title={instanceName}>{instanceName}</p>
                      </div>
                    );
                  })}
                </InfiniteScroll>
              </React.Fragment>
            </div>
          ) : (
            <div className="empty-instances-popup">
              <div className="icon">
                <Icon iconName={ICON.TEXT_DOCUMENT} />
                <span className="sr-only">{TEXT.TEXTDOCUMENT}</span>
              </div>
              <p>{emptyMsg}</p>
            </div>
          )}
        </div>
        <div className="footer-container">
          <button disabled={selectedInstance ? false : true} onClick={() => onDoneClicked()} tabIndex={1}>
            {TEXT.SELECT}
          </button>
          <button onClick={hidePopup} tabIndex={1}>
            {TEXT.CANCEL}
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default InstancesListingPopUp;
